

import { Routes } from "@angular/router";

export const WORK_FLOWS_ROUTES: Routes = [
    {
        path: "workflows",
        title: "Workflows",
        data: {
            icon: 'flowsheet',
            module: 'WORKFLOW'
        },
        loadComponent: () => import("./workflows.component").then(m => m.WorkflowsComponent),
        children: [
            {
                path: 'add',
                title: 'Add Workflow',
                loadComponent: () => import('./workflow-add/workflow-add.component').then(m => m.WorkflowAddComponent)
            },
            {
                path: 'edit/:id',
                title: 'Edit Workflow',
                loadComponent: () => import('./workflow-add/workflow-add.component').then(m => m.WorkflowAddComponent)
            },
            {
                path: '',
                pathMatch: 'full',

                data: {
                    reuse: true
                },
                loadComponent: () => import('./workflow-list/workflow-list.component').then(m => m.WorkflowListComponent)
            }

        ]
    }
];
